/**
 * Normalizes base URL for canonical and hreflang: no www, no trailing slash.
 */
export const normalizeCanonicalUrl = (
	url: string | undefined,
): string | undefined => {
	if (!url) return url;
	return url.replace(/^https?:\/\/www\./, 'https://').replace(/\/+$/, '');
};
